import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class UpdateChatSubjectArgs extends ActionArgs {
  @Field(() => String)
  subject: string

  _id?: string
}

export interface IUpdateChatSubject extends IAction<Chat, UpdateChatSubjectArgs> {}
